import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { AccessType, BuildingContact } from '../../../shared/models/user.model';

export interface UserAddedEvent {
  contact: BuildingContact;
  accessType: AccessType;
  isContact: boolean;
}

@Component({
  selector: 'app-add-user-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule],
  templateUrl: './add-user-modal.component.html'
})
export class AddUserModalComponent implements OnChanges {
  @Input() buildingContacts: BuildingContact[] = [];
  @Input() contacts: BuildingContact[] = [];
  @Input() addedIds: string[] = [];
  @Input() loading = false;

  @Output() userAdded = new EventEmitter<UserAddedEvent>();
  @Output() closed = new EventEmitter<void>();

  icons = Icons;
  readonly AccessType = AccessType;
  readonly accessTypeOptions = Object.values(AccessType);

  activeTab: 'building' | 'contacts' = 'building';
  searchQuery = '';
  selectedAccessType: AccessType = AccessType.AppUser;

  filteredBuildingContacts: BuildingContact[] = [];
  filteredContacts: BuildingContact[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['buildingContacts']) {
      this.filteredBuildingContacts = [...this.buildingContacts];
    }
    if (changes['contacts']) {
      this.filteredContacts = [...this.contacts];
    }
  }

  switchTab(tab: 'building' | 'contacts'): void {
    this.activeTab = tab;
    this.searchQuery = '';
    this.selectedAccessType = tab === 'contacts' ? AccessType.MessageOnly : AccessType.AppUser;
    this.filteredBuildingContacts = [...this.buildingContacts];
    this.filteredContacts = [...this.contacts];
  }

  filterList(): void {
    const q = this.searchQuery.toLowerCase();
    if (this.activeTab === 'building') {
      this.filteredBuildingContacts = this.buildingContacts.filter(
        (u) =>
          (u.name ?? '').toLowerCase().includes(q) ||
          (u.email ?? '').toLowerCase().includes(q) ||
          (u.department ?? '').toLowerCase().includes(q)
      );
    } else {
      this.filteredContacts = this.contacts.filter(
        (u) =>
          (u.name ?? '').toLowerCase().includes(q) ||
          (u.email ?? '').toLowerCase().includes(q) ||
          (u.department ?? '').toLowerCase().includes(q)
      );
    }
  }

  addUser(contact: BuildingContact): void {
    this.userAdded.emit({
      contact,
      accessType: this.selectedAccessType,
      isContact: this.activeTab === 'contacts'
    });
  }

  isAlreadyAdded(id: string): boolean {
    return this.addedIds.includes(id);
  }
}
